import React from 'react';
import { useKindeAuth } from '@kinde-oss/kinde-auth-react';

export default function LoginView() {
  const { login, register } = useKindeAuth();

  return (
    <div className="min-h-screen bg-slate-900 text-white flex flex-col justify-center items-center p-6 relative overflow-hidden">
      {/* Background ambient light */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-blue-600/20 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-1/4 left-1/2 -translate-x-1/2 translate-y-1/2 w-96 h-96 bg-indigo-600/20 rounded-full blur-3xl pointer-events-none" />

      <div className="max-w-md w-full bg-slate-800/80 backdrop-blur-xl p-8 rounded-2xl border border-slate-700/60 shadow-2xl relative z-10 text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-tr from-blue-500 to-indigo-500 mb-6 shadow-lg shadow-blue-500/30">
          <span className="text-3xl">📈</span>
        </div>

        <h1 className="text-3xl font-extrabold text-white mb-2 tracking-tight">
          30-Day Stock Market Course
        </h1>
        <p className="text-slate-400 text-sm mb-8 leading-relaxed">
          Master stock market investing step-by-step. Sign in to access your course modules and cloud-synced progress.
        </p>

        <div className="space-y-3">
          <button
            onClick={() => login()}
            className="w-full py-3.5 px-4 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-500 hover:to-indigo-500 text-white font-semibold rounded-xl transition shadow-lg shadow-blue-600/25 active:scale-[0.98]"
          >
            Sign In to Continue
          </button>
          <button
            onClick={() => register()}
            className="w-full py-3.5 px-4 bg-slate-700/60 hover:bg-slate-700 text-slate-200 font-medium rounded-xl border border-slate-600/50 transition active:scale-[0.98]"
          >
            Create an Account
          </button>
        </div>

        <div className="mt-8 pt-6 border-t border-slate-700/50 text-xs text-slate-500 flex items-center justify-center gap-2">
          <span>🔒 Protected Access</span>
          <span>•</span>
          <span>Cloud Progress Sync</span>
        </div>
      </div>
    </div>
  );
}
